import './FocusBlock.css';
import Task from '../../tasks/Task.js'
import Selector from '../../components/Selector.js';
import AddTask from '../../tasks/AddTask.js';
import React, {useState} from "react";

function FocusBlock(props) {

    const [activeTask, setActiveTask] = useState(0)
    const [showAddTask, setShowAddTask] = useState(false)
    const [activeProjectFilter, setActiveProjectFilter] = useState(null)


    const powerTasks = (props.tasks? (props.tasks.filter((task) => !task.glowTask)) : [])
    const projectFilteredTasks = (activeProjectFilter !== null) ? powerTasks.filter((task) => task.goalTag === activeProjectFilter).filter((task) => task.status==="inProgress") : powerTasks.filter((task) => task.status==="inProgress")    
    function changeActiveTask(differential) {
        if (differential === 1) {
            if ((activeTask < projectFilteredTasks.length-1)) {
                setActiveTask(activeTask+1)
            }
        } else {
            if ((activeTask !== 0)) {
                setActiveTask(activeTask-1)
            }
        }

    }

    function buttonAction() {
        setActiveTask(0)
    }
    
    return (
        <div className="">
            {showAddTask && 
                <AddTask tasks={props.tasks} setTasks={props.setTasks} userProfile={props.userProfile} setUserProfile={props.setUserProfile} setShowAddTask={setShowAddTask}/>}
            <p className="focusHeaderText"> focus </p>
            <div className="taskFocusBlock">
            {projectFilteredTasks.length>0 &&
            <div>
                <Task smallTask={true} index={props.tasks.indexOf(projectFilteredTasks[activeTask])} task={projectFilteredTasks[activeTask]} userProfile={props.userProfile} tasks={props.tasks} setTasks={props.setTasks} setUserProfile={props.setUserProfile} setShowAddTask={buttonAction}/>
                <div className="focusIncrementRow topRow">
                    <p className="focusIncrementText" onClick={() => changeActiveTask(-1)}> back to previous </p>
                    <p className="focusIncrementText" onClick={() => changeActiveTask(1)}> skip this task </p>
                </div>
            </div>
            }
            {projectFilteredTasks.length===0 &&
            <div>
                <p className="focusIncrementText"> need to add more tasks! </p>
            </div>
            }
            <div className="focusIncrementRow">
        <p className="focusIncrementText focusSelectorText"> filter by project: </p>
        <Selector userProfile={props.userProfile} header="" type="projects" setData={setActiveProjectFilter} className="dropdownContainer"/>
    </div>
        <p onClick={() => setShowAddTask(true)} className="addTaskFocusBlock"> add a task</p>
    </div>

            <div onClick={()=>props.setActiveBlock({startHour: 0, endHour: 0, workingBlock: {index: 4, title: "transition", isGlowBlock: false}, subtype: "focusHelp"})} className="helpFocusBlock">
                <p className="smallFocusText"> help i cant focus </p>
            </div>
        </div>
    )
}

export default FocusBlock;